/**
 * labelDesigns — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {SQUARE, tagline, chips, type ToilePack} from './data'

export const labelDesignsPack: ToilePack = {
    slug: 'label-designs',
    category: 'label',
    name: 'Label designs',
    tagline: tagline('labels', 'products', 'styles'),
    chips: chips('products', 'styles'),
    ratio: SQUARE,
    readings: [
        {key: 'candle', label: 'Ember and Oak', subject: 'a candle label, an oak sprig and a small flame motif'},
        {key: 'jam', label: 'Orchard Lane', subject: 'a jam jar label, a plum and two leaves, scalloped edge'},
        {key: 'beer', label: 'Howling Pine', subject: 'a craft beer label, a wolf howling among pines'},
    ],
    styles: [
        {key: 'apothecary', label: 'Apothecary', style: 'vintage apothecary, fine engraved linework', palette: 'aged off-white paper, ornate serif', framing: 'flat label sheet, no jar or bottle'},
        {key: 'minimal', label: 'Modern minimal', style: 'modern minimal, one thin line motif', palette: 'plain white, small clean sans', framing: 'flat label sheet, no jar or bottle'},
        {key: 'botanical', label: 'Botanical', style: 'illustrated botanical, foliage wrapping the edges', palette: 'warm layered color, hand-lettered', framing: 'flat label sheet, no jar or bottle'},
    ],
    directions: ['a coffee bag label instead', 'in deep green and cream', 'with an ingredients line'],
}
